module.exports = __webpack_public_path__ + "static/media/chart_investing_in_reits.18d6aade.png";